cv.ForgotPasswordView = Marionette.LayoutView.extend({
  template: cv.Templates['auth/forgot_password'],

  events : {
    'click .auth-close' : 'authClose',
    'click .button' : 'submit',
    'submit' : 'submit'
  },

  behaviors: [{
    behaviorClass: cv.FormBehavior,
    suppress_notifications : true
  }],

  validation: {
    email: [{
        required: 'true',
        msg: "Required"
    },{
        pattern: 'email',
        msg: 'Invalid e-mail'
    }]
  },

  initialize: function(options){
    // Determine if we are in a window or not
    if(window.name != 'auth'){
      this.in_iframe = false;
    }else{
      this.in_iframe = true;
    }

    this.listenTo(this, 'form:saved', function(){
      $.ajax({
        url: cv.api_path + '/auth/forgot_password',
        dataType: "json",
        data: {
          email : this.model.get('email'),
          campaign_id : cv.campaign.get('id')
        },
        type: "post",
        success: _.bind(function(data){
          vent.trigger('notif:clear');

          this.$el.html(cv.Templates['auth/forgot_password_success']({
            email : this.model.get('email')
          }));
        }, this),
        error: _.bind(function(data){
          Backbone.Validation.error(this, 'email', 'Invalid');
          vent.trigger('notif:error', 'There was an error.');
        }, this)
      });
    }, this);

    this.listenTo(this, 'form:changed', function(model){
    }, this);

    this.listenTo(this, 'form:has_errors', function(){
      vent.trigger('notif:error', 'Please fix the errors on this form.');
    }, this);

    console.log('ForgotPasswordView initialized');
  },

  authClose: function(e){
    e.preventDefault();

    // Close the items
    $('body').addClass('hidden');
    setTimeout(_.bind(function(){
      window.top.postMessage("close-auth", "*");
    }, this), 250);
  },

  submit: function(e){
    e.preventDefault();
    e.stopPropagation();

    this.trigger('form:save');
  },

  onShow: function(){
    // Change document title
    document.title = 'Forgot Password';
  }
});
